import React, { useState } from 'react';
import Button from '../base/Button';
import { supabase } from '../../supabaseClient';
import { trackSignUp, trackFormSubmit } from '../../utils/analytics';
import './EmailSignup.css';

function EmailSignup() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    setError('');

    try {
      // If Supabase is configured, save to database
      if (supabase) {
        console.log('Attempting to save email to Supabase...', email);
        const { data, error: dbError } = await supabase
          .from('waitlist')
          .insert([
            { email: email.trim().toLowerCase() }
          ])
          .select();

        if (dbError) {
          console.error('Supabase error:', dbError);
          // If email already exists, that's okay - just show success
          if (dbError.code === '23505') { // Unique constraint violation
            console.log('Email already exists in waitlist');
            setIsSubmitted(true);
          } else if (dbError.code === '42P01') {
            // Table does not exist
            setError('Waitlist table not found. Please create it in Supabase.');
            console.error('Table "waitlist" does not exist in Supabase');
          } else if (dbError.code === '42501') {
            // Permission denied
            setError('Permission denied. Check RLS policies in Supabase.');
            console.error('Permission denied - check RLS policies');
          } else {
            setError(`Error: ${dbError.message}`);
            throw dbError;
          }
        } else {
          console.log('Email saved successfully:', data);
          setIsSubmitted(true);
          // Track successful sign-up
          trackSignUp('email');
          trackFormSubmit('email_signup');
        }
      } else {
        console.warn('Supabase not initialized - using localStorage fallback');
        // Fallback to localStorage if Supabase not configured
        localStorage.setItem('within_email', email);
        setIsSubmitted(true);
        // Track sign-up even with localStorage fallback
        trackSignUp('email');
        trackFormSubmit('email_signup');
      }
    } catch (err) {
      console.error('Error submitting email:', err);
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="signup" className="email-signup">
      <div className="email-signup-container">
        <h2 className="email-signup-title title-1">
          If this desk life doesn't feel sustainable,
          <br />
          but you still need to keep going...
        </h2>
        <p className="email-signup-subtitle body-text-secondary">
          Join the first students and desk workers testing Within and get early access to the micro-reset app for your laptop.
        </p>

        {!isSubmitted ? (
          <form onSubmit={handleSubmit} className="email-signup-form">
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
              className="email-signup-input"
            />
            <Button
              type="submit"
              variant="primary"
              className="email-signup-button"
              disabled={isLoading}
            >
              {isLoading ? 'Adding...' : 'Start with us'}
            </Button>
            {error && (
              <p className="email-signup-error body-text-secondary" style={{ marginTop: '12px', color: 'var(--color-error, #dc2626)' }}>
                {error}
              </p>
            )}
          </form>
        ) : (
          <div className="email-signup-success animate-fade-up">
            <div className="email-signup-success-icon">
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span className="email-signup-success-text">Done</span>
            </div>
            <p className="email-signup-success-message body-text-secondary">
              Welcome to Within. Keep an eye on your inbox.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

export default EmailSignup;

